export const TOP_MENU_HEIGHT = 46;
export const EXPERIENCE_BUILDER_ID = 'experience-builder';
export const FEATURED_SHADOW = '0 0 0 100vw rgba(78,77,76,0.83)';
